import { Injectable } from '@angular/core';
//import moment from 'moment';
import * as moment from 'moment-timezone'
import { AuthService } from '../api/auth.service';
import { IMarkingWindowConfig } from '../ui-scoring-leader/view-sl-dashboard/data/sample-data';
import { Subject } from 'rxjs';
import { LangService } from './lang.service';

export enum UserContextProperty {
  ACTIVE_CLASSROOM = ':classroomId',
}

@Injectable({
  providedIn: 'root'
})
export class UserSiteContextService {

  contextState:Map<UserContextProperty, string> = new Map();
  markingWindows:IMarkingWindowConfig[] = []; 
  loadMarkingWindowCompleted: Subject<boolean> = new Subject();

  constructor(
    private auth: AuthService,
    private lang: LangService
  ) {
    this.resetContextState()
  }

  resetContextState(){
    this.contextState = new Map();
    this.setActiveClassroom(null)
  }

  processRoutePart(str:string) : string {
    const DEFAULT = '_';
    if (!str){
      return DEFAULT;
    }
    if (this.contextState.has(<UserContextProperty>str)){
      const contextValue = this.contextState.get(<UserContextProperty>str);
      if (!contextValue){
        return DEFAULT;
      }
      return contextValue;
    }
    return str;
  }

  handleClassroomRouteParam(classroomId:string){
    if (!classroomId || classroomId === '_' || classroomId === 'NONE'){
      return null;
    }
    else{
      this.setActiveClassroom(classroomId);
      return classroomId;
    }
  }

  setActiveClassroom(classroomId:string){
    this.contextState.set(UserContextProperty.ACTIVE_CLASSROOM, classroomId);
  }
  
  hasActiveClassroom(){
    if (this.contextState.get(UserContextProperty.ACTIVE_CLASSROOM)){
      return true;
    }
    return false;
  }

  getMarkingWindowId(markingWindowId){
    if(this.markingWindows && this.markingWindows.length){
      return this.markingWindows.find(markingWindow => +markingWindow.meta.markingWindowId === +markingWindowId);
    } 
    return null;
  }

  /**
   * @param isRafi - Pass true if it's for range finder, otherwise uses scoring leader
   * @returns List of marking window objects for which the use has the role
   */
  async loadWindows(isRafi:boolean = false){
    const query = {
      isRafi: isRafi ? 1 : undefined
    }
    const windowRecords = await this.auth.apiFind('/public/scor-lead/windows', {query})
    this.markingWindows = windowRecords.map(record => {
      const testWindowTitle = JSON.parse(record.tw_title)[`${this.lang.c()}`] || JSON.parse(record.tw_title)['en']
      return {
        caption: record.window_name,
        mrkg_group_id: record.group_id,
        tw_type_slug: record.tw_type_slug,
        tw_name: `#${record.tw_id} - ${testWindowTitle}`,
        tw_id: record.tw_id,
        test_ctrl_group_id: record.tw_test_ctrl_group_id,
        tw_academic_year: record.tw_academic_year,
        tw_is_qa: record.tw_is_qa == 1,
        dateFrom: moment.utc(record.start_on).tz('America/New_York').format('MMM. D, YYYY'),
        dateTo: moment.utc(record.end_on).tz('America/New_York').format('MMM. D, YYYY'),
        startOn: record.start_on,
        endOn: record.end_on,
        timeStart: moment.utc(record.start_on).tz('America/New_York').format('HH:mm:ss'),
        timeEnd: moment.utc(record.end_on).tz('America/New_York').format('HH:mm:ss'),
        isPaused: record.is_scoring_disabled == 1,
        stats: {},
        meta:{
          markingWindowId: record.window_id,
          isArchived: record.is_archived == 1,
        }
      }
    })
    if(this.loadMarkingWindowCompleted){
      this.loadMarkingWindowCompleted.next();
    }
    return this.markingWindows;
  }
}
